
export default {
  data() {
    return {
      activeImageIndex: 0,
      activeImage: null,
      imageModalOpen: false,
      galleryItems: [],
      options: [
        {
          name: "image",
          label: "Image",
          type: "image",
          size: "400x400",
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.getGalleryItems();
    }, 500);
  },
  methods: {
    openImage(item, index) {
      if (window.innerWidth && window.innerWidth > 768) {
        this.activeImage = item.image;
        this.activeImageIndex = index;
        this.imageModalOpen = true;
      }
    },
    closeImageModal() {
      this.imageModalOpen = false;
    },

    getGalleryItems() {
      if (
        this.$refs.gallery &&
        this.$refs.gallery.items &&
        this.$refs.gallery.items.length
      ) {
        this.galleryItems = this.$refs.gallery.items;
      }
    },
  },
};
